<dialog appDialog #dialog title="" class="modal-dialog modal-sm">
            <ng-template appDialogContent>
                <p class="message">{{errorMessage}}</p>
                <button class="btn btn-active" (click)="hide()">OK</button>
            </ng-template>
</dialog>
